import { http } from './http';
import type { GlobalSearchResponseDto, NavBarSearchResponseDto } from './types';

/** R19.3: GET /search/global?q= */
export const searchApi = {
  global(q: string): Promise<GlobalSearchResponseDto> {
    return http
      .get<GlobalSearchResponseDto>('/search/global', { params: { q: q.trim() } })
      .then((r) => r.data);
  },

  /** NAV-R1: GET /search?q=&limit= (Admin/Resp) */
  navBar(q: string, limit = 5): Promise<NavBarSearchResponseDto> {
    return http
      .get<NavBarSearchResponseDto>('/search', { params: { q: q.trim(), limit } })
      .then((r) => r.data);
  },
};
